import * as React from "react";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useContent } from "../../context/ContentContext"; // adjust the import path as needed
import ExperiencesAPI from "../../services/ExperiencesAPI";
import { useNavigate } from "react-router";


// Styled IconButton that rotates when expanded.
const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  transform: expand ? "rotate(180deg)" : "rotate(0deg)",
}));

// ExperienceCard component as a constant (arrow function)
const ExperienceCard = ({ experience }) => {
  const [expanded, setExpanded] = useState(false);
  const [system, setSystem] = useState(null);
  const [guide, setGuide] = useState(null);
  const { getItem, getThumbnail } = useContent();
  const navigate = useNavigate(); // ← hook instance

  // Fetch system and guide data when the component mounts or experience changes.
  useEffect(() => {
    const fetchData = async () => {
      if (experience.systemId) {
        const sys = await getItem("systems", experience.systemId);
        setSystem(sys);
      }

      console.log(experience);

      if (experience.guideId) {
        ExperiencesAPI.get(`guides/${experience.guideId}`, { requiresAuth: true })
          .then((response) => {
            setGuide(response.data);
          })
          .catch((error) => {
            console.error("Error fetching guide", error);
          });
      }
    };
    fetchData();
  }, [experience, getItem]);

  const handleExpandClick = () => {
    setExpanded((prev) => !prev);
  };

    const handleCardClicked = () => {
      navigate(`/experiences/${experience.experienceId}`);
    };

  // Use the getThumbnail helper to get the system thumbnail URL.
  const imageUrl = experience.systemId ? getThumbnail(experience.systemId) : "";

  return (
    <Card sx={{ maxWidth: 345, cursor: "pointer" }} onClick={handleCardClicked}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: red[500] }} aria-label="guide">
            {guide?.name ? guide.name[0] : "G"}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={guide?.name || "Guide Title"}
        subheader={system?.name || "System Title"}
      />
      <CardMedia
        onClick={() => console.log("click")}
        component="img"
        height="194"
        image={imageUrl}
        alt={system?.name || "Thumbnail"}
      />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {guide?.description || system?.description || "No description available."}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton> */}
        <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more">
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Experience Details:</Typography>
          <Typography paragraph>Name: {experience.name}</Typography>
          <Typography paragraph>Created: {new Date(experience.metadata.dateCreated).toLocaleDateString()}</Typography>
          <Typography paragraph>Modified: {new Date(experience.metadata.dateModified).toLocaleDateString()}</Typography>
          <Typography paragraph>Organization ID: {experience.organizationId}</Typography>
          <Typography paragraph>System ID: {experience.systemId}</Typography>
          <Typography paragraph>Guide ID: {experience.guideId}</Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ExperienceCard;
